import React, { Component } from 'react'
import Select from 'react-select'

class RenderSelect  extends Component {
	render() {
		const {
			input,
			id,
			label,
			labelClass,
			placeholder,
			options,
			disabled,
			change
		} = this.props

		return(
			<div>
			  <label className={labelClass}>{label}</label>
		  	<Select
				className="select-purple"
				id={id}
				value={input.value}
				onChange={change ? change : input.onChange}
				onBlur={() => input.onBlur(input.value)}
				options={options}
				placeholder={placeholder}
				clearable={false}
				disabled={disabled}
				simpleValue />
			</div>
		)
	}
}


export default RenderSelect
